import { useState } from 'react';
import { parseDelimitedText } from '../utils/dataParsingUtils';

export const useWellTestingData = () => {
    const [tableData, setTableData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [locations, setLocations] = useState([]);
    const [addressField, setAddressField] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleTablePaste = async (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        const parsedData = parseDelimitedText(text);
        const headerRow = parsedData[0];
        setHeaders(headerRow);
        setTableData(parsedData.slice(1));
    };

    const handleFileUpload = async (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target.result;
            const parsedData = parseDelimitedText(text);
            const headerRow = parsedData[0];
            setHeaders(headerRow);
            setTableData(parsedData.slice(1));
        };
        reader.readAsText(file);
    };

    const handleAddressFieldSelect = async (field) => {
        setAddressField(field);
        setIsLoading(true);
        
        const fieldIndex = headers.indexOf(field);
        const addresses = tableData.map(row => row[fieldIndex]);
        
        const geocodedLocations = await Promise.all(
            addresses.map(async (address) => {
                try {
                    const response = await fetch(
                        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
                    );
                    const data = await response.json();
                    if (data && data[0]) {
                        return {
                            address,
                            lat: parseFloat(data[0].lat),
                            lon: parseFloat(data[0].lon),
                            data: tableData[addresses.indexOf(address)]
                        };
                    }
                    return null;
                } catch (error) {
                    console.error('Geocoding error:', error);
                    return null;
                }
            })
        );
        
        setLocations(geocodedLocations.filter(loc => loc !== null));
        setIsLoading(false);
    };

    return {
        tableData,
        headers,
        locations,
        addressField,
        isLoading,
        handleTablePaste,
        handleFileUpload,
        handleAddressFieldSelect
    };
};
